import { Injectable } from '@angular/core';
import { UIRouter } from '@uirouter/angular';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { IAppRouterState } from './router-state';
import { getRouterState } from './router-selectors';
import { RouterGoAction, RouterGoBackAction, RouterNavigationCancelAction } from './router-actions';

@Injectable()
export class RouterService {
    constructor(private router: UIRouter,
                private store$: Store<IAppRouterState>) {}

    public getCurrentState(): Observable<IAppRouterState> {
        return this.store$.select(getRouterState);
    }

    public getParams(): Observable<any> {
        return this.getCurrentState().pipe(map((state: IAppRouterState) => state.params));
    }

    /**
     * Wrapper for UI-Router go.
     * @param {string} stateName
     * @param params
     * @param options
     */
    public go(stateName: string, params?: any, options?: any) {
        this.store$.dispatch(
            new RouterGoAction({
                name: stateName,
                params,
                options,
            })
        );
    }

    public goBack() {
        this.store$.dispatch(new RouterGoBackAction());
    }

    public cancelNavigation(state: string, options?: any) {
        this.store$.dispatch(new RouterNavigationCancelAction({
            state,
            options,
        }));
    }
}
